module.exports = __webpack_public_path__ + "static/media/hocnepal.f38600a9.png";